import { EventEmitter } from '@angular/core';
import { ToastMessageType } from 'Angular/features/components/toast-messages/toast-messages.enum';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { RegistrationsService } from 'ClientManagementApp/ts/services/registrations.service';
import * as i0 from "@angular/core";
import * as i1 from "ClientManagementApp/ts/services/registrations.service";
import * as i2 from "Angular/features/components/toast-messages/page-toast-messages-service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function RegistrationToActiveModalComponent_label_9_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 10)(1, "input", 11);
    i0.ɵɵlistener("change", function RegistrationToActiveModalComponent_label_9_Template_input_change_1_listener() { const portfolio_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.togglePortfolio(portfolio_r2.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 12);
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const portfolio_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.selectedPortfolioIds.has(portfolio_r2.id));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(portfolio_r2.name);
} }
export class RegistrationToActiveModalComponent {
    constructor(registrationsService, toastService) {
        this.registrationsService = registrationsService;
        this.toastService = toastService;
        this.confirmHandler = new EventEmitter();
        this.open = false;
        this.portfolios = [];
        this.selectedPortfolioIds = new Set();
    }
    openModal() {
        this.selectedPortfolioIds = new Set();
        this.registrationsService.getUnderlyingClientPortfolios(this.registrationId).subscribe({
            next: (response) => {
                this.portfolios = response.portfolios;
                this.open = true;
            },
            error: (err) => {
                this.toastService.addMessage(err.errorMessage, ToastMessageType.ERROR);
                this.confirmHandler.emit(false);
            },
        });
    }
    togglePortfolio(portfolioId) {
        if (this.selectedPortfolioIds.has(portfolioId)) {
            this.selectedPortfolioIds.delete(portfolioId);
        }
        else {
            this.selectedPortfolioIds.add(portfolioId);
        }
    }
    get isApplyDisabled() {
        return this.selectedPortfolioIds.size === 0;
    }
    submit() {
        const portfolios = this.portfolios.map((p) => ({
            ...p,
            is_internal: this.selectedPortfolioIds.has(p.id),
        }));
        this.registrationsService.updateUnderlyingClientPortfolios(this.registrationId, portfolios).subscribe({
            next: () => {
                this.open = false;
                this.confirmHandler.emit(true);
            },
            error: (err) => {
                this.toastService.addMessage(err.errorMessage, ToastMessageType.ERROR);
            },
        });
    }
    cancel() {
        this.open = false;
        this.confirmHandler.emit(false);
    }
}
RegistrationToActiveModalComponent.ɵfac = function RegistrationToActiveModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegistrationToActiveModalComponent)(i0.ɵɵdirectiveInject(i1.RegistrationsService), i0.ɵɵdirectiveInject(i2.PageToastMessagesService)); };
RegistrationToActiveModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegistrationToActiveModalComponent, selectors: [["ycn-registration-to-active-modal"]], inputs: { registrationId: "registrationId" }, outputs: { confirmHandler: "confirmHandler" }, standalone: false, decls: 12, vars: 5, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "text-gray-30"], [1, "text-bold", "mb-12"], [1, "text-small", "mb-12"], [1, "custom-controls-stacked", "custom-controls-stacked-airy"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [1, "divider-horizontal"], [3, "submitHandler", "cancelHandler", "submitButtonText", "disableSubmission"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function RegistrationToActiveModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function RegistrationToActiveModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function RegistrationToActiveModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵtext(5, "Select which portfolios you will now be managing.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtext(7, "By selecting the portfolios you will be managing for your active client, the portfolios will be logged as Internal.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, RegistrationToActiveModalComponent_label_9_Template, 5, 2, "label", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(10, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ycn-simple-modal-footer", 9);
        i0.ɵɵlistener("submitHandler", function RegistrationToActiveModalComponent_Template_ycn_simple_modal_footer_submitHandler_11_listener() { return ctx.submit(); })("cancelHandler", function RegistrationToActiveModalComponent_Template_ycn_simple_modal_footer_cancelHandler_11_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Active Client Portfolios");
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.portfolios);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("submitButtonText", "Apply")("disableSubmission", ctx.isApplyDisabled);
    } }, dependencies: [i3.NgForOf, i4.ModalBaseComponent, i5.SimpleModalFooterComponent, i6.SimpleModalHeaderComponent], encapsulation: 2 });
